// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3fXYJ","footer":"ReportModalFilter_footer__3AVYF"};